import React from 'react';
import { useLocation } from 'react-router-dom';

const WIDE_ROUTES = ['/observer'];

function Wrapper({ children }) {
    const location = useLocation();
    const isWide = WIDE_ROUTES.some(path => location.pathname.startsWith(path));

    return (
        <div
            className={`w-full min-h-screen mx-auto overflow-x-clip ${isWide ? 'max-w-[1900px]' : 'max-w-[1400px]'}`}
        >
            {children}
        </div>
    );
}

export default Wrapper;